import { APIClient } from '@innerhive-internal/innerhive-api-client';

/**
 * Puts a file in the uploads bucket by the route the api offers for it, and returns the url the file
 * is served from. Any record that shows a file (a photo, an attachment) is then given that url.
 */
export class UploadsClient {
    static inject = () => [APIClient];
    constructor(private apiClient: APIClient) {}

    upload = async (file: File): Promise<{ url: string }> => {
        const entry = await this.apiClient.entry();
        const { uploadUrl, cdnUrl, headers } = await this.apiClient.post(entry.links.uploadsV2, { fileName: file.name });

        const res = await window.fetch(uploadUrl, {
            method: 'PUT',
            body: file,
            headers
        });
        if (res.status !== 200) {
            throw new Error(`Upload failed with status ${res.status}`);
        }

        return { url: cdnUrl };
    };
}
